/**
 * @generated SignedSource<<f4ff150831b759834cdee2870f1618de>>
 * @relayHash 4f06927b0ca26743f2bbe2732781f3ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc6f73afd41fe12a8cca911ee28bae412d214bbb9603afba302431a9c5584b6e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CreateTeamModalQuery$variables = Record<PropertyKey, never>;
export type CreateTeamModalQuery$data = {
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type CreateTeamModalQuery = {
  response: CreateTeamModalQuery$data;
  variables: CreateTeamModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CreateTeamModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateTeamModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4f06927b0ca26743f2bbe2732781f3ed",
    "id": "bc6f73afd41fe12a8cca911ee28bae412d214bbb9603afba302431a9c5584b6e",
    "metadata": {},
    "name": "CreateTeamModalQuery",
    "operationKind": "query",
    "text": "query CreateTeamModalQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "536629206db11dd275cbf79a453e8385";

export default node;
